module.exports = __webpack_public_path__ + "img/hebaimofakoudaiWu.min.0400e951.png";